/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'RACE_ETHNIC_GROUP_SKIN_COLOR',
              'SEX_GENDER',
              'RELIGION',
              'POLITICAL_OPINION',
              'NATIONAL_EXTRACTION',
              'SOCIAL_ORIGIN',
              'HIV_AIDS_STATUS_REAL_OR_PERCEIVED_',
              'SEXUAL_ORIENTATION',
              'PREGNANCY_MATERNITY_STATUS',
              'MARITAL_STATUS',
              'AGE',
              'NATIONALITY_FOREIGN_MIGRANT_WORKER_STATUS',
              'FAMILY_RESPONSIBILITIES',
              'INDONESIA_DOES_THE_FACILITY_COMPLY_WITH_LEGAL_REQUIREMENTS_CONC1',
              'IF_YES_DOES_THE_FACILITY_OR_RECRUITING_AGENCY_EVER_REQUEST_THAT',
              'VIETNAM_DOES_THE_FACILITY_COMPLY_WITH_LEGAL_REQUIREMENTS_CONCER1',
              'INDONESIA_DOES_THE_FACILITY_COMPLY_WITH_LEGAL_REQUIREMENTS_CONC2',
              'CAMBODIA_DOES_THE_FACILITY_INCLUDE_THE_ENTIRE_PERIOD_OF_CONTINU',
              'VIETNAM_DOES_THE_FACILITY_COMPLY_WITH_LEGAL_REQUIREMENTS_CONCER2',
              'PERMANENT_WORKERS',
              'TEMPORARY_WORKERS',
              'CASUAL_WORKERS',
              'PART_TIME_WORKERS',
              'AGENCY_CONTRACT_WORKERS',
              'CONTRACT_WORKERS_WHO_ARE_NOT_PART_OF_THE_PRODUCTION_PROCESS',
              'WORKERS_UNDER_PROBATION',
              'WORKERS_WHO_ARE_TRAINEES_APPRENTICES_OR_INTERNS',
              'OTHER',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    which_of_the_following_is_a_factor_in_decisions_on_hiring_selec: valueSchema,
  },
}
